import { createRoute } from "@tanstack/react-router";

import { InsightsContent } from "../components/screens/InsightsContent";
import { rootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/insights",
  component: InsightsContent,
});
